import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12.5 16h-6.5a2 2 0 0 1 -2 -2v-4a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v4","key":"svg-0"}],["path",{"d":"M16 18h6","key":"svg-1"}]]

const IconCodeVariableMinus = createReactComponent('outline', 'code-variable-minus', 'CodeVariableMinus', __iconNode);

export default IconCodeVariableMinus;